import {MeshLocation} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshLocation';
import {MeshState} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshState';
import {SheetId} from '@mintdata/mint-kit/api/models/Identifiers';
import {action} from 'mobx';

export abstract class AbstractSheetCopyPasteController
{
    public abstract copySlotToClipboard(sheetId:SheetId,
                                        isCut?:boolean,
                                        isNestedSheet?:boolean):void;

    public abstract pasteSlotFromClipboard(sheetId:SheetId,
                                           event:React.ClipboardEvent<HTMLDivElement>,
                                           isNested:boolean):void;

    @action.bound
    public adjustSelectedRange(activeSheet:MeshState,
                               colIndexFrom:number,
                               rowIndexFrom:number,
                               colsCount:number,
                               rowsCount:number):void
    {
        const details = activeSheet.details;

        const colIndexTo = colIndexFrom + colsCount - 1;
        const rowIndexTo = rowIndexFrom + rowsCount - 1;

        details.selectionRangeFrom = new MeshLocation(
            colIndexFrom,
            rowIndexFrom
        );

        details.selectionRangeTo = new MeshLocation(
            colIndexTo,
            rowIndexTo
        );

        if( details.activeCell.colIndex < colIndexFrom )
            details.activeCell = details.activeCell.makeCopyWithCol(colIndexFrom);
        else if( details.activeCell.colIndex > colIndexTo )
            details.activeCell = details.activeCell.makeCopyWithCol(colIndexTo);

        if( details.activeCell.rowIndex < rowIndexFrom )
            details.activeCell = details.activeCell.makeCopyWithRow(rowIndexFrom);
        else if( details.activeCell.rowIndex > rowIndexTo )
            details.activeCell = details.activeCell.makeCopyWithRow(rowIndexTo);
    }
}
